import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import simpleReactValidator from 'simple-react-validator';

import { createClaim } from '../actions/claims';
import { listInsurers } from '../actions/insurers';
import { listCurrencies, fetchCurrencyRate } from '../actions/currencies';

import StatusMessages from './StatusMessages';

class FileClaimForm extends Component {
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      claim: {
        insurer: '',
        policy_number: '',
        claim_type: '',
        place_of_loss: '',
        date_of_loss: '',
        claim_amount: '',
        packing_list: '',
        bill_of_ladding: '',
        invoice: '',
        claim_status: 'SUBMITED_TO_INSURER',
        currency: {
          currency_code: '',
          currency_value: ''
        }
      },
      submitted: false
    };
  }

  componentDidMount() {
    const { listInsurers, listCurrencies } = this.props;

    listInsurers();
    listCurrencies();
  }

  handleChange = e => {
    const { name, value } = e.target;
    const { claim } = this.state;

    this.setState({
      claim: {
        ...claim,
        [name]: value
      }
    });
  };

  handleClaimCurrency = e => {
    const { claim } = this.state;
    const curr = e.target.value;

    if (curr && curr !== '') {
      this.props.fetchCurrencyRate(curr).then(response => {
        const code = response.value.data
          ? response.value.data.currency_code
          : null;
        const rate = response.value.data ? response.value.data.rate : null;
        this.setState({
          claim: {
            ...claim,
            currency: {
              currency_code: code,
              currency_value: rate
            }
          }
        });
      });
    }
  };

  onAddFiles = e => {
    const { claim } = this.state;
    const { name, files } = e.target;

    this.setState({
      claim: {
        ...claim,
        [name]: files[0]
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    this.setState({ submitted: true });
    const { claim } = this.state;
    const { createClaim } = this.props;
    if (this.validator.allValid()) {
      this.validator.hideMessages();
      createClaim(claim);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { claim, submitted } = this.state;
    const { claims } = this.props || {};
    const { currencies } = this.props.currency || [];
    const { insurers } = this.props || {};

    return (
      <form
        id="claim-form"
        className="form form-horizontal claimfrm col-sm-12"
        onSubmit={this.handleSubmit}
      >
        {claims && claims.errorFileClaim ? (
          <StatusMessages type="error" message={claims.errorMessageFileClaim} />
        ) : null}
        {claims && claims.claimSuccess ? (
          <StatusMessages type="success" message={[claims.successMessage]} />
        ) : null}
        <div className="form-group">
          <label className="control-label col-sm-4">Select Insurer</label>
          <div className="col-sm-8">
            <select
              className="form-control"
              id="insurer"
              name="insurer"
              onChange={this.handleChange}
            >
              <option value="">-- Select an Insurer --</option>
              {insurers &&
                insurers.insurers.map(insurer => {
                  return (
                    <option key={insurer.id} value={insurer.id}>
                      {insurer.company_name}
                    </option>
                  );
                })}
            </select>
            {this.validator.message(
              'insurer',
              claim.insurer,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">Policy Number</label>
          <div className="col-sm-8">
            <input
              type="text"
              id="policy_number"
              className="form-control"
              name="policy_number"
              value={claim.policy_number}
              onChange={this.handleChange}
            />

            {this.validator.message(
              'policy_number',
              claim.policy_number,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">Claim Type</label>
          <div className="col-sm-8">
            <select
              className="form-control"
              id="claim_type"
              name="claim_type"
              onChange={this.handleChange}
            >
              <option value="PARTIAL_CLAIM">Partial Claim</option>
              <option value="FULL_CLAIM">Full Claim</option>
            </select>

            {this.validator.message(
              'claim_type',
              claim.claim_type,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">Place of Loss</label>
          <div className="col-sm-8">
            <input
              type="text"
              id="place_of_loss"
              className="form-control"
              name="place_of_loss"
              value={claim.place_of_loss}
              onChange={this.handleChange}
            />
            {this.validator.message(
              'place_of_loss',
              claim.place_of_loss,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">Date of Loss</label>
          <div className="col-sm-8">
            <input
              type="date"
              id="date_of_loss"
              className="form-control"
              name="date_of_loss"
              value={claim.date_of_loss}
              onChange={this.handleChange}
            />
            {this.validator.message(
              'date_of_loss',
              claim.date_of_loss,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">Choose currency</label>
          <div className="col-sm-8">
            <select
              name="currency"
              id="currency"
              className="form-control"
              onChange={this.handleClaimCurrency}
            >
              {!claim.currency && <option value=""> select_currency </option>}
              {currencies &&
                currencies.map((currency, index) => {
                  return (
                    <option key={index} value={currency.id}>
                      {currency.code + ' - ' + currency.name}
                    </option>
                  );
                })}
            </select>
            {this.validator.message(
              'currency',
              claim.currency.currency_value,
              'required',
              'text-danger'
            )}
          </div>
        </div>

        <div className="form-group">
          <label className="control-label col-sm-4">Claim Amount</label>
          <div className="col-sm-8">
            <input
              type="number"
              id="claim_amount"
              className="form-control"
              name="claim_amount"
              value={claim.claim_amount}
              onChange={this.handleChange}
            />

            {this.validator.message(
              'claim_amount',
              claim.claim_amount,
              'required|gt:0',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">Packing List</label>
          <div className="col-sm-8">
            <input
              type="file"
              id="packing_list"
              name="packing_list"
              onChange={this.onAddFiles}
            />
            {this.validator.message(
              'packing_list',
              claim.packing_list,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">Bill of Lading</label>
          <div className="col-sm-8">
            <input
              type="file"
              id="bill_of_ladding"
              name="bill_of_ladding"
              onChange={this.onAddFiles}
            />
            {this.validator.message(
              'bill_of_ladding',
              claim.bill_of_ladding,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-4">
            Proof of purchase (Proforma, Supplier invoice, Receipt)
          </label>
          <div className="col-sm-8">
            <input
              type="file"
              id="invoice"
              name="invoice"
              onChange={this.onAddFiles}
            />

            {this.validator.message(
              'invoice',
              claim.invoice,
              'required',
              'text-danger'
            )}
          </div>
        </div>
        <br />
        <br />
        <div className="col-sm-offset-4 col-sm-8">
          <button type="submit" className="btn btn-warning">
            File Claim
          </button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  insurers: state.insurers,
  claims: state.claims,
  currency: state.currency
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { createClaim, listInsurers, listCurrencies, fetchCurrencyRate },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileClaimForm);



// WEBPACK FOOTER //
// ./src/components/FileClaimForm.jsx